import { DeliveryType } from '@interfaces';
import { useSegment } from '@hooks/useSegment';
import { GetCheckoutAddressQueryResponse } from '@queries/checkout/queries/address';
import { getCommuneZone } from '@utils';

import { RootDiv, TextDiv, TextSwitcher } from '../styles/Switcher.styles';

interface SwitcherProps {
  isDelivery: boolean;
  setIsDelivery: (value: boolean) => void;
  handleDeliveryType: (value: DeliveryType) => void;
  setDeliverySelected: (value: boolean) => void;
  currentOrder: GetCheckoutAddressQueryResponse['currentOrder'];
}

export function Switcher(props: SwitcherProps) {
  const {
    isDelivery,
    setIsDelivery,
    handleDeliveryType,
    setDeliverySelected,
    currentOrder,
  } = props;
  const { track } = useSegment();

  const handleDelivery = () => {
    setDeliverySelected(false);
    setIsDelivery(true);
    handleDeliveryType('DELIVERY');
    const commune = currentOrder?.address?.commune;
    const zone = getCommuneZone(currentOrder?.address?.commune)?.zoneType;
    void track('address select', {
      commune,
      zone,
      deliveryType: 'DELIVERY',
    });
  };

  const handlePickup = () => {
    setIsDelivery(false);
    handleDeliveryType('PICK_UP');
    const commune = currentOrder?.address?.commune;
    const zone = getCommuneZone(currentOrder?.address?.commune)?.zoneType;
    void track('address select', {
      commune,
      zone,
      deliveryType: 'PICK_UP',
    });
  };

  return (
    <RootDiv>
      <TextDiv isDelivery={isDelivery} onClick={handleDelivery}>
        <TextSwitcher isDelivery={isDelivery}>A domicilio</TextSwitcher>
      </TextDiv>
      <TextDiv isDelivery={!isDelivery} onClick={handlePickup}>
        <TextSwitcher isDelivery={!isDelivery}>Retiro en tienda</TextSwitcher>
      </TextDiv>
    </RootDiv>
  );
}
